import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../Common/Alert";
import DatatableFunc from "../../Common/DatatableFunc";
import Http from "../../Common/Http";
// import { LoaderComponent } from "../../Common/LoaderComponent";
import Swal from "sweetalert2";
import IsLogin from "../../Common/IsLogin";
import ReactDataTable from "../../Common/ReactDataTable";

const BallMillCharge = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(true);
  const today = new Date().toISOString().split('T')[0];

  const [inputs, setInputs] = useState({
    start_date: today,
    end_date: today,
  });

  const formSubmit = async () => {
    setLoading(true);
    const submissionInputs = { ...inputs };
    const queryParams = new URLSearchParams({
      start_date: submissionInputs.start_date,
      end_date: submissionInputs.end_date
    });

    try {
      const response = await Http.get(
        `/ball-mill-charge-report?${queryParams.toString()}`
      );
      setReceiveData(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error on form submit:", error);
      setLoading(false);
    }
  };

  const fetchData = async () => {
    setLoading(true); // Start loading

    try {
      const res = await Http.get(`/ball-mill-charge-report`);
      setReceiveData(res.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false); // Stop loading regardless of the outcome
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    // Ensure the selected date falls within the current month range
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);


  const cols = [
    { field: "code", header: "Code" },
    { field: "name", header: "Name" },
    { field: "charging_qty", header: "Charging qty" },
    { field: "date", header: "Date" },
  ];


  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Total Ball Mill Charge</h5>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              <div className="am-pagebody">
                <div className="card pd-sm-40">
                  <div className="row">
                    <div className="col-lg">
                      <label htmlFor="">From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="start_date"
                        value={inputs.start_date}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg">
                      <label htmlFor="">To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="end_date"
                        value={inputs.end_date}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg mt-4">
                      <button
                        className="btn btn-primary btn-block mg-b-10"
                        onClick={formSubmit}
                      >
                        <i className="fa fa-send mg-r-10"></i> Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BallMillCharge;
